import ApiService from '../../../../shared/services/api-service';
import commonActionCreators from '../../../../shared/store/common/action-creators';
import departmentActionsCreators from '../../department/action-creators';
import trainingPhasesCommitTypes from '../commit-types';
import trainingPhasesActionsCreators from './training-phases';
import trainingPhaseReportsActionsCreators from './training-phase-reports';
import notificationsActionsCreator from '../../notifications/action-creators';

const trainingPhasesReportsActions = {
  addScheduledReport(reportGuid, type) {
    return (dispatch) => {
      console.log('addScheduledReport', reportGuid, type)
      dispatch(this.setIsAddingScheduledReport(reportGuid));
      dispatch(departmentActionsCreators.setFormFor(type));
      dispatch(departmentActionsCreators.fetchDepartmentForms());
    };
  },
  closeAddScheduledReport() {
    return (dispatch) => {
      dispatch(this.setIsAddingScheduledReport(null));
    };
  },
  closeScheduleReports() {
    return (dispatch) => {
      dispatch(this.setIsSchedulingReports(false));
    };
  },
  createScheduledReports(formData) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('createScheduledReports'));
      const data = await ApiService.post('/api/v1/scheduled-reports', formData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('createScheduledReports'));
      if (data) {
        dispatch(this.createScheduledReportsSuccess(data));
      }
      return Promise.resolve(data);
    };
  },
  createScheduledReportsSuccess(created) {
    return (dispatch) => {
      dispatch(trainingPhaseReportsActionsCreators.pushReports(created.data));
      dispatch(this.setIsSchedulingReports(false));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Reports scheduled'))
    };
  },
  deleteScheduledReport(reportGuid) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('deleteScheduledReport'));
      const data = await ApiService.delete(`/api/v1/scheduled-reports/${reportGuid}`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('deleteScheduledReport'));
      if (data) {
        dispatch(this.deleteScheduledReportSuccess(data));
      }
      return Promise.resolve();
    };
  },
  deleteScheduledReportSuccess(deleted) {
    return (dispatch) => {
      dispatch(trainingPhaseReportsActionsCreators.removeReport(deleted.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Scheduled reports deleted'))
    };
  },
  scheduleReports() {
    return (dispatch) => {
      dispatch(this.setIsSchedulingReports(true));
    };
  },
  sendReminder(formData) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('sendReminder'));
      const postData = { ...formData };
      // Remove redundant
      delete postData.guid;
      const data = await ApiService.post(`/api/v1/reports/${formData.guid}/reminder`, postData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('sendReminder'));
      if (data) {
        dispatch(this.sendReminderSuccess(data));
      }
      return Promise.resolve();
    };
  },
  sendReminderSuccess(updated) {
    return (dispatch) => {
      dispatch(trainingPhaseReportsActionsCreators.replaceReport(updated.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Reminder sent'))
    };
  },
  setIsAddingScheduledReport(isAddingScheduledReport) {
    return {
      isAddingScheduledReport,
      type: trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_ADDING_SCHEDULED_REPORT,
    };
  },
  setIsSchedulingReports(isSchedulingReports) {
    return {
      isSchedulingReports,
      type: trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_SCHEDULING_REPORTS,
    };
  },
};

export default trainingPhasesReportsActions;
